import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../ui-component/iconify';
import TableStyle from '../../ui-component/TableStyle';
import { useState, useEffect } from 'react';
import {
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Card,
  Popover,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import moment from 'moment';
import { getApi, patchApi } from 'views/services/api';
import AddProperty from './AddEmployee.js';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ChangeShift from './ChangeShift';
import EditEmployee from './EditEmployee';
import DeleteEmployee from './DeleteEmployee';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// List of menu items
const menuItems = [
  'Dashboard',
  'Room Type Master',
  'Room Management',
  'Reservation',
  'Staff Management',
  'Restaurant',
  'Customers',
  'Reports',
  'Complaint',
  'Kitchen Order Ticket',
  'Invoice',
  'Laundary',
  'Expenses',
  'Subscriptions',
  'Payments',
  'Hotel Profile'
];

const StaffManagment = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openChangeShift, setOpenChangeShift] = useState(false);
  const [currentShift, setCurrentShift] = useState('');
  const [employeeID, setEmployeeId] = useState('');
  const [staffData, setstaffData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowData, setRowData] = useState();
  const [permissionsAnchorEl, setPermissionsAnchorEl] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const navigate = useNavigate();

  //function for the dropdowns
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handlePermissionsClick = (event, row) => {
    setPermissionsAnchorEl(event.currentTarget);
    setRowData(row);
    setSelectedPermissions(row.permissions || []);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPermissionsAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const openPermissions = Boolean(permissionsAnchorEl);

  // function for fetching all the contacts data from the db
  const fetchstaffData = async () => {
    try {
      const response = await getApi(`api/employee/viewallemployee/${hotel?.hotelId}`);
      setstaffData(response?.data?.employeeData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchstaffData();
  }, [openAdd, openEdit, openDelete, openChangeShift]);

  // add employee dialog
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  // edit employee dialog
  const handleOpenEditEmployee = (_id) => {
    console.log('_id in handle edit =>', _id);
    setOpenEdit(true);
  };
  const handleCloseEditEmployee = () => {
    setOpenEdit(false);
    handleClose();
  };

  // delete employee dialog
  const handleOpenDeleteEmployee = (_id) => {
    console.log('_id in handle delete =>', _id);
    setOpenDelete(true);
  };
  const handleCloseDeleteEmployee = () => {
    setOpenDelete(false);
    handleClose();
  };

  // view employee
  const handleOpenview = (_id) => {
    console.log('_id ==>', _id);
    navigate(`/dashboard/employee/view/${rowData?._id}`);
  };

  // change shift dialog
  const handleOpenChangeShift = (employeeData) => {
    setCurrentShift(employeeData.shift);
    setEmployeeId(employeeData._id);
    setOpenChangeShift(true);
  };
  const handleCloseChangeShift = () => {
    setOpenChangeShift(false);
  };

  const handlePermissionsChange = (event) => {
    const value = event.target.name;
    setSelectedPermissions((prev) => (prev?.includes(value) ? prev.filter((permission) => permission !== value) : [...prev, value]));
  };

  const handleSavePermissions = async () => {
    console.log('rowData._id ===>', rowData._id);
    console.log('selectedPermissions here ======>', selectedPermissions);

    try {
      await patchApi(`api/employee/addPermissions/${rowData._id}`, {
        permissions: selectedPermissions
      });
      fetchstaffData();
    } catch (error) {
      console.log(error);
    }
    handleClose();
  };

  const columns = [
    {
      field: `fullName`,
      headerName: 'Employee Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleOpenViewNameClick = () => {
          navigate(`/dashboard/employee/view/${params.row._id}`);
        };
        return <Box onClick={() => handleOpenViewNameClick()}>{params.value}</Box>;
      }
    },
    {
      field: 'employeeType',
      headerName: 'Employee Type',
      flex: 1
    },
    {
      field: 'shift',
      headerName: 'Working Shift',
      flex: 1
    },
    {
      field: 'createdDate',
      headerName: 'Joining Date',
      flex: 1,
      renderCell: (params) => {
        return <Box>{moment(params?.value).format('YYYY-MM-DD ( HH:mm:ss )')}</Box>;
      }
    },
    {
      field: 'salary',
      headerName: 'Salary',
      flex: 1,
      renderCell: (params) => {
        return <Box>{hotel?.currencyCode} {params.value}</Box>;
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        console.log('params ===>', params);
        return (
          <>
            <div>
              <IconButton aria-describedby={params?.row._id} variant="contained" onClick={(event) => handleClick(event, params?.row)}>
                <MoreVertIcon />
              </IconButton>

              <Popover
                id={params?.row._id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
              >
                <MenuItem onClick={() => handleOpenEditEmployee(params?.row._id)} disableRipple>
                  <EditIcon style={{ marginRight: '8px' }} />
                  Edit
                </MenuItem>
                <MenuItem onClick={() => handleOpenview(params.row._id)} disableRipple>
                  <VisibilityIcon style={{ marginRight: '8px', color: 'green' }} />
                  View
                </MenuItem>
                <MenuItem onClick={() => handleOpenDeleteEmployee(params?.row._id)} sx={{ color: 'red' }} disableRipple>
                  <DeleteIcon style={{ marginRight: '8px', color: 'red' }} />
                  Delete
                </MenuItem>

                <MenuItem variant="contained" onClick={(event) => handlePermissionsClick(event, params.row)}>
                  <AddCircleOutlineIcon style={{ marginRight: '8px', color: 'blue' }} />
                  Add Permission
                </MenuItem>
                <Popover
                  open={openPermissions}
                  anchorEl={permissionsAnchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                >
                  <List>
                    {menuItems.map((item) => (
                      <ListItem key={item}>
                        <FormControlLabel
                          control={
                            <Checkbox checked={selectedPermissions?.includes(item)} onChange={handlePermissionsChange} name={item} />
                          }
                          label={item}
                        />
                      </ListItem>
                    ))}
                    <ListItem>
                      <Button variant="contained" onClick={handleSavePermissions}>
                        Save Permissions
                      </Button>
                    </ListItem>
                  </List>
                </Popover>

                <MenuItem
                  variant="contained"
                  startIcon={<ChangeCircleIcon icon="eva:plus-fill" />}
                  onClick={() => handleOpenChangeShift(params.row)}
                >
                  <ChangeCircleIcon style={{ marginRight: '8px' }} />
                  Change Shift
                </MenuItem>
              </Popover>
            </div>
          </>
        );
      }
    }
  ];

  return (
    <>
      <AddProperty open={openAdd} handleClose={handleCloseAdd} />
      <DeleteEmployee open={openDelete} handleClose={handleCloseDeleteEmployee} employeeID={rowData?._id} />
      <EditEmployee open={openEdit} handleClose={handleCloseEditEmployee} employeeData={rowData} />
      <ChangeShift open={openChangeShift} handleClose={handleCloseChangeShift} employeeID={employeeID} currentShift={currentShift} />
      <Box>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom>
              Employee List
            </Typography>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              Add Employee
            </Button>
          </Stack>
          <Card>
            <TableStyle>
              <Box sx={{ height: '70vh', width: '100%' }}>
                {staffData && (
                  <DataGrid
                    rows={staffData}
                    columns={columns}
                    components={{ Toolbar: GridToolbar }}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 5
                        }
                      }
                    }}
                    pageSizeOptions={[5, 10, 25]}
                    disableRowSelectionOnClick
                    getRowId={(row) => row?._id}
                  />
                )}
              </Box>
            </TableStyle>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default StaffManagment;
